import { render, staticRenderFns } from "./AnnualGroupingCreate.vue?vue&type=template&id=51210708&scoped=true&"
import script from "./AnnualGroupingCreate.vue?vue&type=script&lang=js&"
export * from "./AnnualGroupingCreate.vue?vue&type=script&lang=js&"
import style0 from "./AnnualGroupingCreate.vue?vue&type=style&index=0&id=51210708&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51210708",
  null
  
)

export default component.exports